import { render, staticRenderFns } from "./FundApproval.vue?vue&type=template&id=0f005b2e&scoped=true"
import script from "./FundApproval.vue?vue&type=script&lang=js"
export * from "./FundApproval.vue?vue&type=script&lang=js"
import style0 from "./FundApproval.vue?vue&type=style&index=0&id=0f005b2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f005b2e",
  null
  
)

export default component.exports